export default function Happy() {
  return (
    <div
      className="ion-icon-happy"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M103.272,253.324
		c-8.272-5.574-9.249-15.145-3.747-22.207C110.074,217.573,123.25,208,144.137,208s34.174,9.593,44.655,23.174
		c5.464,7.076,3.765,17.011-3.787,22.144c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.716-6.223
		c-3.398-4.416-7.621-9.777-17.23-9.777c-9.561,0-13.818,5.387-17.269,9.821c-3.163,4.069-8.274,6.178-13.669,6.179
		C109.618,256,106.186,255.287,103.272,253.324z M394.245,310.945C370.607,356.719,316.344,384,256.004,384
		c-61.869,0-117.55-28.235-138.556-73.677c-3.663-7.939-0.191-17.383,7.734-21.057c2.137-0.978,4.363-1.463,6.658-1.463
		c6.163,0,11.818,3.61,14.407,9.199C162.164,331.438,206.27,352,256.004,352c48.602,0,91.8-20.269,110.053-55.615
		c2.746-5.301,8.148-8.588,14.104-8.588c2.532,0,5.06,0.621,7.308,1.796C395.201,293.598,398.254,303.184,394.245,310.945z
		 M409.006,253.317c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.717-6.223c-3.398-4.416-7.62-9.777-17.23-9.777
		c-9.561,0-13.817,5.387-17.268,9.821c-3.163,4.069-8.275,6.178-13.67,6.179c-3.581,0-7.014-0.713-9.928-2.676
		c-8.271-5.574-9.248-15.145-3.746-22.207C334.074,217.573,347.25,208,368.137,208c20.888,0,34.175,9.593,44.656,23.174
		C418.257,238.25,416.558,248.185,409.006,253.317z"/>
</g>
</svg>
`,
      }}
    />
  )
}
